import { useEffect } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../../components/BannerOne";
import CardsFormatOne from "../../../components/CardsFormatOne";
import IntroductionBlock from "../../../components/IntroductionBlock";
// Constants
import { TITLE, SUB_TITLE, TITLE_CARDS, ALL_CARD_ROWS } from "./CustomSolutionsConstants";
import { TEXT_STEP_1, TEXT_STEP_2, TEXT_STEP_3, TEXT_STEP_4 } from "./CustomSolutionsConstants";
import { TITLE_1, INTRO_TEXT, TITLE_2, TEXT_2, TITLE_3, TEXT_3 } from "./CustomSolutionsConstants";
// Images
import banner from '../../../assets/img/partnerPortal/EnablementSales/full wave.png';
import cloudOps from '../../../assets/img/partnerProgram/cloud_ops.png';
import appDeveloper from '../../../assets/img/partnerProgram/app_developer.png';
import development from '../../../assets/img/partnerPortal/customSolution/Development.png';
import enterprise from '../../../assets/img/partnerPortal/customSolution/Enterprise.png';
import expert from '../../../assets/img/partnerPortal/customSolution/Expert.png';
import fast from '../../../assets/img/partnerPortal/customSolution/Fast.png';
import tools from '../../../assets/img/partnerPortal/customSolution/Tools.png';
import learn from '../../../assets/img/partnerPortal/customSolution/Learn.png'
import lightBulb from '../../../assets/img/partnerPortal/customSolution/LightBulb.png';
import serviceEndorsement from '../../../assets/img/partnerPortal/customSolution/appDeveloperSpecialization.svg';
import appDeveloperBadge from '../../../assets/img/partnerProgram/appDeveloper.png';
import solutionArch from '../../../assets/img/partnerPortal/customSolution/CustomSolutionArchitecture.png';
import market from '../../../assets/img/partnerPortal/customSolution/Marketecture.png';
import custom from '../../../assets/img/partnerPortal/customSolution/contact.svg';
// Scss
import '../../../assets/css/partnerProgram.scss';
import '../../../assets/css/partnerPortal/appDeveloper.scss';
import '../../../assets/css/partnerPortal/sales.scss';
import '../../../assets/css/geral.scss';
import TitleSubTitleCenter from "../../../components/TitleSubTitleCenter";
import CardWithNoBorder from "../../../components/CardWithNoBorder";
import CardRole from "../../../components/CardRole";

function CustomSolutions() {

  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();


  }, []);

  return (
    <>
        <BannerOne bannerImage={banner} title={TITLE} subTitle={SUB_TITLE} hasNoButton={true} />
        <IntroductionBlock eyeBrownHeader={""}  title={TITLE_1} text={INTRO_TEXT} image={market} />
        <IntroductionBlock eyeBrownHeader={""}  title={TITLE_2} text={TEXT_2} />
        <IntroductionBlock eyeBrownHeader={""}  title={TITLE_3} text={TEXT_3} />

        <CardsFormatOne eyeBrownHeader={""} title={TITLE_CARDS} subTitle={""} cards={ALL_CARD_ROWS} />
        <IntroductionBlock eyeBrownHeader={""}  title={"A safe, governed, and secure platform"} text={""} image={solutionArch} removeMargin={true} />

        <div className="containerAll margin96Botton">
            <TitleSubTitleCenter title={"Grow your Dynatrace related revenue"} subTitle={""} />

            <div className="w-100 d-flex align-items-center flex-column">
                <div className="FlexToBlock align-items-start w-100">
                    <CardWithNoBorder icon={expert} eyeBrow={""} title={""} imageWidth={"40%"} subTitle={"Monetize your domain expertise with custom apps and differentiated service offerings"} />
                    <CardWithNoBorder icon={development} eyeBrow={""} title={""} imageWidth={"40%"} subTitle={"Create integration and customization service revenue by selling billable hours for app development and customizations"} />
                    <CardWithNoBorder icon={fast} eyeBrow={""} title={""} imageWidth={"40%"}  subTitle={"Innovate faster and reduce time to market and time to adoption"} />
                </div>
                <div className="FlexToBlock align-items-center justify-content-center w-100">
                    <CardWithNoBorder icon={tools} eyeBrow={""} title={""} imageWidth={"40%"} subTitle={"Productize services with recurring revenue from support, maintenance, and updates"} />
                    <CardWithNoBorder icon={enterprise} eyeBrow={""} title={""} imageWidth={"40%"} subTitle={"Increase your deal size by leveraging custom solutions to integrate Dynatrace in enterprise-wide engineering projects"} />
                </div>
            </div>
            {/* <ButtonOne target="_blank" text={"Get started"} classNameOfA={"width13"} className={"pad7"}  link={"https://university.dynatrace.com/ondemand/course/35226?content=overview"} withoutIcon={true} /> */}
        </div>

        <div className="d-flex flex-column align-items-center width67 mx-auto ">
            <div className="d-flex flex-column align-items-center width63 mb-2 ">
                <div className="d-flex align-items-center align-self-stretch textStyle colorBlack m-auto pb-3 text-center">What’s in it for you?</div>
                {/* <div className="introframeSubText text-center m-auto">
                    Build on the Observability Certification with specializations that will help develop your integration, automation, and development expertise.
                </div> */}
            </div>
            <div className="align-items-start displayFlex justify-content-center">
                <div className="d-flex flex-column align-items-center cardBackground width46 mr-4 ml-3">
                    <img src={cloudOps} width={"100%"} />
                    <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                        <div className="d-flex flex-column align-items-center align-self-stretch mb-4">
                            <div className="d-flex align-items-start align-self-stretch cardTitleApp mb-2">Focus on value creation</div>
                            <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">
                                Differentiate and specialize with custom solutions
                                by extending Dynatrace and adding value with your
                                domain expertise. You can add new use cases that
                                are not covered out of the box and create apps with
                                the same Dynatrace look and feel and toolset.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column align-items-center cardBackground width46 mr-4 ">
                    <img src={appDeveloper} width={"100%"} />
                    <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                        <div className="d-flex flex-column align-items-center align-self-stretch mb-4">
                            <div className="d-flex align-items-start align-self-stretch cardTitleApp mb-2">Dynatrace takes care of the rest</div>
                            <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">
                                Bring the logic to where the data is captured and
                                stored. This eliminates the data flow and privacy
                                challenges with no need to think about SSO, IAM,
                                secrets, credentials, infrastructure, etc.
                            </div>
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="containerAll">
            <div className="width66 mb-4">
                <div className="introframeHeader">
                    Get inspired, start learning,<br/> and become an expert
                </div>
            </div>

            <div className="flexToBlockCard align-items-center w-100 margin96Botton">
                <CardRole icon={learn} title="" subTitle={TEXT_STEP_1} addMargin={"margin32"} imageWidth={"107%"} />
                <CardRole icon={lightBulb} title="" subTitle={TEXT_STEP_2} addMargin={"margin32"} imageWidth={"107%"} />
                <CardRole icon={appDeveloperBadge} title="" subTitle={TEXT_STEP_3} addMargin={"margin32"} />
                <CardRole icon={custom} title="" subTitle={TEXT_STEP_4} addMargin={"margin32 noMargin"} imageWidth={"70%"} />

            </div>
        </div>

    </>
  );

  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default CustomSolutions;

